import { Navigate, Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";
import { useWorkspaceStore } from "@mobile/stores";
import { LoadingOverlay } from "@repo/share-log-ui/ui/loading";

type RouteStatus = "loading" | "has_workspaces" | "no_workspaces";

export function WorkspaceRoute() {
  const location = useLocation();
  const {
    workspaces,
    fetchWorkspaces,
    fetchLastVisit,
    lastVisitWorkspaceId,
    workspacesStatus,
  } = useWorkspaceStore();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      setIsInitialized(false);
      await fetchWorkspaces();
      await fetchLastVisit();
      if (!cancelled) {
        setIsInitialized(true);
      }
    };

    void init();

    return () => {
      cancelled = true;
    };
  }, [fetchWorkspaces, fetchLastVisit]);

  const routeStatus: RouteStatus = !isInitialized
    ? "loading"
    : workspacesStatus === "success"
      ? workspaces.length > 0
        ? "has_workspaces"
        : "no_workspaces"
      : "no_workspaces";

  if (routeStatus === "loading") {
    return <LoadingOverlay />;
  }

  if (location.pathname === "/") {
    if (routeStatus === "no_workspaces") {
      return <Navigate to="/workspace/empty" replace />;
    }

    if (routeStatus === "has_workspaces") {
      const targetWorkspaceId = lastVisitWorkspaceId ?? workspaces[0]?.id;
      if (targetWorkspaceId) {
        return <Navigate to={`/workspace/${targetWorkspaceId}`} replace />;
      }
    }
  }

  return <Outlet />;
}
